import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import axios from "@/axios";
import './static/css/global.css'
import './static/css/vueloopscroll.css';
Vue.config.productionTip = false
Vue.prototype.$http = axios
import animated from 'animate.css'
// Vue.use(animated)
import vueSeamlessScroll from 'vue-seamless-scroll'
Vue.use(vueSeamlessScroll)
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
